module.exports = __webpack_public_path__ + "img/icon-13.02d64efb.svg";